/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const FieldSize = core.serialization.enum_(["xs", "s", "m", "l", "xl"]);
